import math from "core/math";

export default function(targetImagePlane, referenceImagePlane) {
  const points = math.Projection.planePlaneIntersection(
    targetImagePlane,
    referenceImagePlane
  );

  if (!points) {
    return;
  }

  return {
    start: math.Projection.projectPatientPointToImagePlane(
      points.start,
      targetImagePlane
    ),
    end: math.Projection.projectPatientPointToImagePlane(
      points.end,
      targetImagePlane
    )
  };
}
